<div *ngIf="selectedPayment" class="mat-form-field-outline mat-form-field-outline-thick">
    <div class="payment" fxLayoutAlign="start center" fxLayout="row">
        <div *ngIf="!selectedPayment else paymentpresentation" i18n class="empty">please select payment method.</div>
        <ng-template #paymentpresentation>
            <div class="image" fxLayoutAlign="start center"><img [src]="selectedPayment?.thumbnail?.url" /></div>
        </ng-template>
        <div class="select-icon">
            <img src="{{licenceService.getKey('icon-arrow-down')}}" alt="icon-arrow-down" class="s">
        </div>
    </div>
</div>